let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dxnac")).then(() => parcelRequire('ciD6c'));